import { useEffect, useRef } from "react";
import type { DrawingActivity } from "./activityTypes";
import { renderGuidePreview } from "./GuideRenderer";

interface ActivityPreviewProps {
  activity: DrawingActivity;
}

const PREVIEW_WIDTH = 320;
const PREVIEW_HEIGHT = 190;

export function ActivityPreview({ activity }: ActivityPreviewProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    canvas.width = PREVIEW_WIDTH;
    canvas.height = PREVIEW_HEIGHT;
    const context = canvas.getContext("2d");
    if (!context) return;
    context.clearRect(0, 0, PREVIEW_WIDTH, PREVIEW_HEIGHT);
    renderGuidePreview(context, activity.previewPrimitives, {
      width: PREVIEW_WIDTH,
      height: PREVIEW_HEIGHT,
      zoom: 1,
    });
  }, [activity]);

  return (
    <canvas
      aria-label={`${activity.title} activity illustration`}
      className="activity-card__preview"
      ref={canvasRef}
      role="img"
    />
  );
}
